(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const scrollToSection = (section) => {
    const header = document.querySelector('sticky-header, .header-wrapper, header');
    const offset = header ? Math.min(header.getBoundingClientRect().height, 140) + 12 : 80;
    const top = section.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
  };

  const linkRating = (section) => {
    if (section.dataset.jbcRating !== 'true' || window.__jbcRatingLinked) return;
    window.__jbcRatingLinked = true;
    const selector = '.product-rating-badge, .review-badge, .jdgm-preview-badge';
    document.querySelectorAll(selector).forEach((badge) => {
      if (section.contains(badge)) return;
      badge.style.cursor = 'pointer';
      if (!badge.hasAttribute('tabindex')) badge.setAttribute('tabindex', '0');
      badge.setAttribute('role', 'link');
      badge.setAttribute('aria-label', 'See customer stories and reviews');
    });
    const go = (event) => {
      const badge = event.target.closest && event.target.closest(selector);
      if (!badge || section.contains(badge)) return;
      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      event.stopPropagation();
      scrollToSection(section);
    };
    document.addEventListener('click', go, true);
    document.addEventListener('keydown', go, true);
  };

  const init = (section) => {
    if (section.dataset.jbcReady === 'true') return;
    section.dataset.jbcReady = 'true';
    linkRating(section);

    const stage = section.querySelector('[data-jbc-stage]');
    const items = [...section.querySelectorAll('[data-jbc-item]')];
    const prev = section.querySelector('[data-jbc-prev]');
    const next = section.querySelector('[data-jbc-next]');
    const status = section.querySelector('[data-jbc-status]');

    if (!stage || items.length < 2) return;
    section.classList.add('is-carousel');

    const interval = Math.max(3, Number(section.dataset.interval) || 6) * 1000;
    let index = 0;
    let timer;
    let inView = false;
    let held = false;

    const fit = () => {
      const active = items[index];
      if (active) stage.style.height = active.offsetHeight + 'px';
    };

    const render = (nextIndex) => {
      index = (nextIndex + items.length) % items.length;
      items.forEach((item, i) => {
        let pos = i - index;
        if (Math.abs(pos) > items.length / 2) pos -= Math.sign(pos) * items.length;
        item.dataset.position = String(Math.max(-2, Math.min(2, pos)));
        item.classList.toggle('is-active', i === index);
        item.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        item.inert = i !== index;
      });
      if (status) status.textContent = `${index + 1} / ${items.length}`;
      fit();
      window.requestAnimationFrame(fit);
    };

    const stop = () => { window.clearInterval(timer); timer = undefined; };
    const start = () => {
      stop();
      if (reduce || held || !inView || document.hidden) return;
      timer = window.setInterval(() => render(index + 1), interval);
    };
    const go = (nextIndex) => { render(nextIndex); start(); };

    prev && prev.addEventListener('click', () => go(index - 1));
    next && next.addEventListener('click', () => go(index + 1));
    section.addEventListener('focusin', () => { held = true; stop(); });
    section.addEventListener('focusout', (event) => {
      if (section.contains(event.relatedTarget)) return;
      held = false;
      start();
    });
    document.addEventListener('visibilitychange', start);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => { inView = entry.isIntersecting; start(); }, { threshold: 0.2 }).observe(section);
    } else {
      inView = true;
    }

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => fit());
      items.forEach((item) => resizeObserver.observe(item));
    }
    window.addEventListener('resize', fit);
    window.addEventListener('load', fit);
    document.addEventListener('visibilitychange', fit);
    items.forEach((item) => item.querySelectorAll('img').forEach((img) => img.addEventListener('load', fit)));

    let dragging = false;
    let axis = null;
    let startX = 0;
    let startY = 0;
    const endDrag = (event) => {
      if (!dragging) return;
      dragging = false;
      held = false;
      if (axis === 'x') {
        const dx = event.clientX - startX;
        if (Math.abs(dx) > 40) { go(dx < 0 ? index + 1 : index - 1); return; }
      }
      axis = null;
      start();
    };
    stage.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      dragging = true;
      axis = null;
      startX = event.clientX;
      startY = event.clientY;
      held = true;
      stop();
    });
    stage.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      if (!axis && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) axis = Math.abs(dx) * 1.15 > Math.abs(dy) ? 'x' : 'y';
      if (axis === 'x') event.preventDefault();
    }, { passive: false });
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);
    stage.addEventListener('pointerleave', (event) => { if (dragging && event.pointerType !== 'touch') endDrag(event); });

    render(0);
    start();
  };

  const boot = () => document.querySelectorAll('[data-jbc]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-jbc]');
    if (section) { window.__jbcRatingLinked = false; init(section); }
  });
})();
